// carousel-component.js
document.addEventListener("alpine:init", () => {
  Alpine.data("carousel", () => ({
    canScrollLeft: false,
    canScrollRight: true,

    init() {
      this.checkScrollButtons();

      const observer = new MutationObserver(() => {
        this.checkScrollButtons();
        // Scroll to selected item when mutations occur
        this.scrollToSelected();
      });
      observer.observe(this.$refs.carousel, { childList: true, subtree: true });

      window.addEventListener("resize", () => this.checkScrollButtons());
      window.addEventListener("variant:changed", () => {
        setTimeout(() => {
          this.checkScrollButtons();
          this.scrollToSelected();
        }, 100);
      });

      // Initial scroll to selected after everything loads
      setTimeout(() => {
        this.checkScrollButtons();
        this.scrollToSelected();
      }, 100);

      // Additional check after a longer delay to ensure everything is rendered
      setTimeout(() => {
        this.scrollToSelected();
      }, 500);

      this.$refs.carousel.addEventListener("scroll", () =>
        this.checkScrollButtons()
      );

      window.addEventListener("variant:updated", () => {
        setTimeout(() => {
          this.checkScrollButtons();
        }, 100);
      });
    },

    checkScrollButtons() {
      const carousel = this.$refs.carousel;

      this.canScrollLeft = carousel.scrollLeft > 0;

      this.canScrollRight =
        carousel.scrollWidth > carousel.clientWidth + carousel.scrollLeft + 1;
    },

    scrollToSelected() {
      const carousel = this.$refs.carousel;
      const selectedButton = carousel.querySelector(
        ".xp-option-button.selected"
      );

      if (selectedButton) {
        const carouselRect = carousel.getBoundingClientRect();
        const buttonRect = selectedButton.getBoundingClientRect();

        // Check if the selected button is not fully visible
        const isOutOfViewLeft = buttonRect.left < carouselRect.left;
        const isOutOfViewRight = buttonRect.right > carouselRect.right;

        if (isOutOfViewLeft || isOutOfViewRight) {
          // Calculate the position to scroll to center the selected button
          const scrollLeft =
            carousel.scrollLeft +
            buttonRect.left -
            carouselRect.left -
            (carouselRect.width - buttonRect.width) / 2;

          carousel.scrollTo({
            left: scrollLeft,
            behavior: "smooth",
          });
        }
      }
    },

    scrollLeft() {
      const carousel = this.$refs.carousel;
      const scrollAmount = carousel.clientWidth * 0.8;
      carousel.scrollBy({ left: -scrollAmount, behavior: "smooth" });
    },

    scrollRight() {
      const carousel = this.$refs.carousel;
      const scrollAmount = carousel.clientWidth * 0.8;
      carousel.scrollBy({ left: scrollAmount, behavior: "smooth" });
    },
  }));
});
